import { icons as appIcons } from "@/model/solution/apps";
import { iconDashboard } from "@/design/icon/iconConst";

/**
 * City Center titles
 * @type {Readonly<{ProcessConfiguration: string, ProcessAssociation: string, UserManagement: string, Dashboard: string, StatusConfiguration: string, WorkflowSetup: string, RoleGroup: string, UserGroup: string}>}
 */
const titles = Object.freeze({
  Dashboard: "Dashboard",
  UserManagement: "User Management",
  RoleGroup: "Role Group",
  // RoleGroupAssociation: "Role Group Association",
  WorkflowSetup: "Workflow Setup",
  ProcessConfiguration: "Process Configuration",
  ProcessAssociation: "Process Association",
  StatusConfiguration: "Status Configuration",
  UserGroup: "User Group",
  ApprovalGroup: "Approval Group"
});

/**
 * City Center names
 * @type {Readonly<{ProcessConfiguration: string, ProcessAssociation: string, UserManagement: string, Dashboard: string, StatusConfiguration: string, WorkflowSetup: string, RoleGroup: string, UserGroup: string}>}
 */
const names = Object.freeze({
  Dashboard: "Dashboard",
  UserManagement: "UserManagement",
  RoleGroup: "RoleGroup",
  // RoleGroupAssociation: "RoleGroupAssociation",
  WorkflowSetup: "WorkflowSetup",
  ProcessConfiguration: "ProcessConfiguration",
  ProcessAssociation: "ProcessAssociation",
  StatusConfiguration: "StatusConfiguration",
  UserGroup: "UserGroup",
  ApprovalGroup: "ApprovalGroup"
});

/**
 * City Center icons
 * @type {Readonly<{Account: string, ProcessConfiguration: string, ProcessAssociation: string, UserManagement: string, Dashboard: string, StatusConfiguration: string, WorkflowSetup: string, RoleGroup: string, UserGroup: string}>}
 */
const icons = Object.freeze({
  Dashboard: iconDashboard,
  Account: "mdi-card-account-details",
  UserManagement: "mdi-badge-account-outline",
  RoleGroup: "mdi-account-lock-outline",
  // RoleGroupAssociation: "mdi-account-lock-outline",
  WorkflowSetup: "mdi-cog-outline",
  ProcessConfiguration: "mdi-cog-outline",
  ProcessAssociation: "mdi-cog-outline",
  StatusConfiguration: "mdi-cog-outline",
  UserGroup: "mdi-account-group-outline",
  ApprovalGroup: "mdi-account-group-outline"
});

/**
 * City Center routes
 * @type {Readonly<{ProcessConfiguration: string, ProcessAssociation: string, UserManagement: string, Dashboard: string, NotImplemented: string, StatusConfiguration: string, WorkflowSetup: string, RoleGroup: string, UserGroup: string}>}
 */
const routes = Object.freeze({
  Dashboard: "Dashboard",
  NotImplemented: "NotImplemented",
  UserManagement: "UserManagement",
  RoleGroup: "RoleGroup",
  // RoleGroupAssociation: "RoleGroupAssociation",
  WorkflowSetup: "WorkflowSetup",
  ProcessConfiguration: "ProcessConfiguration",
  ProcessAssociation: "ProcessAssociation",
  StatusConfiguration: "StatusConfiguration",
  UserGroup: "UserGroup",
  ApprovalGroup: "ApprovalGroup"
});

/**
 * City Center entities
 * @type {Readonly<{ProcessConfiguration: string, ProcessAssociation: string, UserManagement: string, Dashboard: string, StatusConfiguration: string, WorkflowSetup: string, RoleGroup: string, UserGroup: string}>}
 */
const entities = Object.freeze({
  Dashboard: "Dashboard",
  UserManagement: "User Management",
  RoleGroup: "Role Group",
  // RoleGroupAssociation: "Role Group Association",
  WorkflowSetup: "Workflow Setup",
  ProcessConfiguration: "Process Configuration",
  ProcessAssociation: "Process Association",
  StatusConfiguration: "Status Configuration",
  UserGroup: "User Group",
  ApprovalGroup: "Approval Group"
});

/**
 * City Center page titles
 * @type {Readonly<{ProcessConfiguration: string, ProcessAssociation: string, UserGroupUsers: string, UserManagement: string, UserGroupAssociations: string, Dashboard: string, StatusConfiguration: string, UserAssociation: string, RoleGroup: string, UserGroup: string}>}
 */
const pageTitles = Object.freeze({
  Dashboard: "Dashboard",
  UserManagement: "User Management",
  RoleGroup: "Role Group",
  RoleGroupAssociation: "Role Group Association",
  ProcessConfiguration: "Process Configuration",
  ProcessAssociation: "Process Association",
  StatusConfiguration: "Status Configuration",
  UserGroup: "User Group",
  ApprovalGroup: "Approval Group",
  UserAssociation: "User Association",
  UserGroupUsers: "User Group Users",
  ApprovalGroupUsers: "Approval Group Users",
  UserGroupAssociations: "User Group Associations",
  ApprovalGroupAssociations: "Approval Group Associations"
});

/**
 * City Center modules
 * @type {({route: string, icon: string, name: string, title: string, entity: string}|{route: string, icon: string, name: string, title: string, entity: string}|{route: string, icon: string, name: string, title: string, entity: string}|{route: string, icon: string, name: string, title: string, entity: string}|{route: string, icon: string, name: string, title: string, entity: string})[]}
 */
const modules = Object.freeze([
  {
    title: titles.Dashboard,
    icon: icons.Dashboard,
    name: names.Dashboard,
    route: routes.Dashboard,
    entity: entities.Dashboard
  },
  {
    title: titles.UserManagement,
    icon: icons.UserManagement,
    name: names.UserManagement,
    route: routes.UserManagement,
    entity: entities.UserManagement
  },
  {
    title: titles.RoleGroup,
    icon: icons.RoleGroup,
    name: names.RoleGroup,
    route: routes.RoleGroup,
    entity: entities.RoleGroup
  },
  // {
  //   title: titles.RoleGroupAssociation,
  //   icon: icons.RoleGroupAssociation,
  //   name: names.RoleGroupAssociation,
  //   route: routes.RoleGroupAssociation,
  //   entity: entities.RoleGroupAssociation
  // },
  {
    title: titles.WorkflowSetup,
    icon: icons.WorkflowSetup,
    name: names.WorkflowSetup,
    route: routes.WorkflowSetup,
    entity: entities.WorkflowSetup
  },
  {
    title: titles.ProcessConfiguration,
    icon: icons.ProcessConfiguration,
    name: names.ProcessConfiguration,
    route: routes.ProcessConfiguration,
    entity: entities.ProcessConfiguration
  },
  {
    title: titles.ProcessAssociation,
    icon: icons.ProcessAssociation,
    name: names.ProcessAssociation,
    route: routes.ProcessAssociation,
    entity: entities.ProcessAssociation
  },
  {
    title: titles.StatusConfiguration,
    icon: icons.StatusConfiguration,
    name: names.StatusConfiguration,
    route: routes.StatusConfiguration,
    entity: entities.StatusConfiguration
  },
  {
    title: titles.UserGroup,
    icon: icons.UserGroup,
    name: names.UserGroup,
    route: routes.UserGroup,
    entity: entities.UserGroup
  },
  {
    title: titles.ApprovalGroup,
    icon: icons.ApprovalGroup,
    name: names.ApprovalGroup,
    route: routes.ApprovalGroup,
    entity: entities.ApprovalGroup
  }
]);

/**
 * City Center dashboard
 * @type {Readonly<{route: string, icon: string, name: string, title: string, entity: string}>}
 */
const dashboard = Object.freeze({
  title: "Dashboard",
  icon: appIcons.CityCenter,
  name: "Dashboard",
  route: "Dashboard",
  entity: "Dashboard"
});

export {
  modules,
  routes,
  titles,
  names,
  icons,
  entities,
  dashboard,
  pageTitles
};
